var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0013 13.5007C13.223 13.5007 15.8346 10.889 15.8346 7.66732C15.8346 4.44566 13.223 1.83398 10.0013 1.83398C6.77964 1.83398 4.16797 4.44566 4.16797 7.66732C4.16797 10.889 6.77964 13.5007 10.0013 13.5007Z",
    stroke: "url(#paint0_linear_15461_96154)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.84036 12.5747L5.83203 20.1664L9.9987 17.6664L14.1654 20.1664L13.157 12.5664",
    stroke: "url(#paint1_linear_15461_96154)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_15461_96154",
    x1: 11.6716,
    y1: 0.542529,
    x2: 8.06131,
    y2: 3.9465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D1DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71ABEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_15461_96154",
    x1: 11.1917,
    y1: 11.7251,
    x2: 8.83715,
    y2: 14.1594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#71D1DD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#71ABEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAward);
export default __webpack_public_path__ + "static/media/award.24439ecb4b0dcd1cb77460b92942109f.svg";
export { ForwardRef as ReactComponent };